import { render, staticRenderFns } from "./RedirectToV1.vue?vue&type=template&id=2cccfc8c&scoped=true"
import script from "./RedirectToV1.vue?vue&type=script&lang=js"
export * from "./RedirectToV1.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cccfc8c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/render/project/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2cccfc8c')) {
      api.createRecord('2cccfc8c', component.options)
    } else {
      api.reload('2cccfc8c', component.options)
    }
    module.hot.accept("./RedirectToV1.vue?vue&type=template&id=2cccfc8c&scoped=true", function () {
      api.rerender('2cccfc8c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/RedirectToV1.vue"
export default component.exports